// eslint-disable-next-line import/prefer-default-export
export const conditionsInfo = {
    location: 0,
    version: {
        enable: 0,
        gray: 0,
        formal: 0,
    },
    channel: [],
};

export const ssoId = {
    prod: '098ae84eb2',
    dev: 'b8c3b3747b'
}

export const grades = [
    {
        key: 'count',
        text: '总次数',
    },
    {
        key: 'avg',
        text: '平均值',
    },
    {
        key: 'tp50.0',
        text: 'TP50',
    },
    {
        key: 'tp90.0',
        text: 'TP90',
    },
    {
        key: 'tp95.0',
        text: 'TP95',
    },
    {
        key: 'tp99.0',
        text: 'TP99',
    },
];

export const crashType = [
    {
        key: 'crash',
        text: 'crash',
    },
    {
        key: 'anr',
        text: 'anr',
    },
    {
        key: 'lag_log',
        text: 'lag_log',
    },
    {
        key: 'catchexception',
        text: 'catchexception',
    },
    {
        key: 'fmp',
        text: 'fmp',
    },
    {
        key: 'mrn',
        text: 'mrn',
    },
    {
        key: 'mmp',
        text: 'mmp',
    },
    {
        key: 'picasso',
        text: 'picasso',
    },
    {
        key: 'eh',
        text: 'eh',
    },
];

export const metricGrade = ['tp5', 'tp10', 'tp25', 'tp50', 'tp75', 'tp90', 'tp95', 'count'];

export const metricType = [
    {
        key: 'startup',
        text: '冷启动',
    },
    {
        key: 'page_load_time',
        text: '页面加载',
    },
    {
        key: 'custom_load_time',
        text: '自定义测速',
    },
];

export const commonFormHintIcon = {
    color: '#1890ff',
    margin: '0px 4px 0px 4px'
};

export const mockChart = {
    time: [
        '03:30',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
        '04:00',
    ],
    crash: {
        tab: ['crash', 'caughtCrash', 'anr', 'lag', 'jni', 'java'],
        tableData: [
            {
                key: 'a',
                y1: [
                    '12',
                    '21',
                    '22',
                    '33',
                    null,
                    null,
                    '22',
                    '33',
                    'null',
                    '21',
                ],
                y2: [
                    '12',
                    '2',
                    '212',
                    '330',
                    '121',
                    '251',
                    '202',
                    '343',
                    '102',
                    '211',
                ],
                y3: [
                    '102',
                    '211',
                    '222',
                    '33',
                    '1',
                    null,
                    '22',
                    '33',
                    '41',
                    '21',
                ],
                y4: [
                    '102',
                    '20',
                    '22',
                    '10',
                    '17',
                    '81',
                    '92',
                    '33',
                    '12',
                    '41',
                ],
            },
            {
                key: 'b',
                y1: [
                    '120',
                    '210',
                    '220',
                    '330',
                    '140',
                    '250',
                    '260',
                    '370',
                    '180',
                    '290',
                ],
                y2: [
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                ],
            },
        ],
    },
    api: {
        tab: ['crash', 'caughtCrash', 'anr', 'lag', 'jni', 'java'],
        tableData: [
            {
                key: 'a',
                y1: [
                    '12',
                    '21',
                    '22',
                    '33',
                    null,
                    null,
                    '22',
                    '33',
                    'null',
                    '21',
                ],
                y2: [
                    '12',
                    '2',
                    '212',
                    '330',
                    '121',
                    '251',
                    '202',
                    '343',
                    '102',
                    '211',
                ],
                y3: [
                    '102',
                    '211',
                    '222',
                    '33',
                    '1',
                    null,
                    '22',
                    '33',
                    '41',
                    '21',
                ],
                y4: [
                    '102',
                    '20',
                    '22',
                    '10',
                    '17',
                    '81',
                    '92',
                    '33',
                    '12',
                    '41',
                ],
            },
            {
                key: 'b',
                y1: [
                    '120',
                    '210',
                    '220',
                    '330',
                    '140',
                    '250',
                    '260',
                    '370',
                    '180',
                    '290',
                ],
                y2: [
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                ],
            },
        ],
    },
    mrn: {
        tab: [
            '首页列表',
            '图片CDN',
            'rcmd',
            'mapsdk_all',
            'waimai_api_all',
        ],
        tabData: [
            {
                key: 'a',
                y1: [
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                ],
                y2: [
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                ],
            },
            {
                key: 'b',
                y1: [
                    '120',
                    '210',
                    '220',
                    '330',
                    '140',
                    '250',
                    '260',
                    '370',
                    '180',
                    '290',
                ],
                y2: [
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                    '22',
                    '33',
                    '12',
                    '21',
                ],
            },
        ],
    },
};
